import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IButtonProps {
  theme: any;
  default?: boolean;
  outline?: boolean;
  transparent?: boolean;
  size?: string;
  kt?: boolean;
  full?: boolean;
}

const ButtonBase = styled.button<IButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  ${({ size = 'md', disabled = false, theme, full = false }) => {
    return `
      ${full && `width: 100%;`};
      ${disabled ? `cursor: none;` : `cursor: pointer;`};
      ${theme.buttonStyles[size]};
      }
    `;
  }};
  ${({ size = 'md', theme }) =>
    size === 'md' &&
    theme.media.fold`
    padding: ${rem(8)} ${rem(12)};
    font-size: ${rem(12)};
    line-height: ${rem(14)};
  `}
`;

export const Button = styled(ButtonBase)<IButtonProps>`
  ${({ kt = false, disabled = false, theme }) =>
    disabled
      ? `
      background: ${theme.color['gray-500']}};
      border: 1px solid ${theme.color['gray-500']};
      color: ${theme.color.white};
    `
      : kt
      ? `
      background: ${theme.color['gray-800']}};
      border: 1px solid ${theme.color['gray-800']};
      color: ${theme.color.white};    
      `
      : `
      background: ${theme.color['primary-100']}};
      border: 1px solid ${theme.color['primary-100']};
      color: ${theme.color.white};
    `}
`;

export const ButtonOutline = styled(ButtonBase)<IButtonProps>`
  background: ${({ theme }) => theme.color.white};
  ${({ kt = false, disabled = false, theme }) =>
    disabled
      ? `
    color: ${theme.color['gray-600']};
    border: 1px solid ${theme.color['gray-500']};
  `
      : kt
      ? `
  
    color: ${theme.color['gray-800']};
    border: 1px solid ${theme.color['gray-800']};
  `
      : `
    color: ${theme.color['primary-100']};
    border: 1px solid ${theme.color['primary-100']};
  `};
`;

export const ButtonTransparent = styled(ButtonBase)<IButtonProps>`
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color['transparent']};
  color: ${({ kt = false, disabled = false, theme }) =>
    disabled ? theme.color['gray-600'] : kt ? theme.color['gray-800'] : theme.color['primary-100']};
`;

export const ButtonMedia = styled(ButtonBase)<IButtonProps>`
  background:${({ theme }) => theme.color['primary-50']};
  border: 1px solid ${({ theme }) => theme.color['transparent']};
  color:${({ theme }) => theme.color['primary-100']};
`